module.exports = __webpack_public_path__ + "media/images/prizeBox__bg--mobile-0a24af09cb7fc153e8983892c9070d54.png";